import { getEnv } from '@atlassian/pillar/runtime/env';

export const PUG_CLOUD_ID = 'DUMMY-a5a01d21-1cc3-4f29-9565-f2bb8cd969f5';
export const HELLO_CLOUD_ID = 'a436116f-02ce-4520-8fbb-7301462a1674';

// TODO: review what we actually need and remove prod values that point to internal domains
const config = {
	atlassianHomeUrl: 'https://home.stg.atlassian.com',
	atlassianAccountUrl: 'https://id.stg.internal.atlassian.com',
	serviceUrl: 'https://twg-microsite-bifrost.stg-east.frontend.public.atl-paas.net',
	graphStoreUrl: 'https://ari-graph-store.staging.atl-paas.net',
};

// When running locally (via pillar dev), always route graph-store through the local proxy to
// avoid CORS issues. The proxy target (staging vs production) is configured in pillar.config.ts.
const isLocalDev =
	typeof window !== 'undefined' &&
	(window.location.hostname === 'localhost' || window.location.hostname.includes('localhost'));

const environmentOverrides: Partial<Record<ReturnType<typeof getEnv>, Partial<typeof config>>> = {
	staging: {
		atlassianHomeUrl: 'https://home.stg.atlassian.com',
		atlassianAccountUrl: 'https://id.stg.internal.atlassian.com',
		serviceUrl: 'https://twg-microsite-bifrost.stg-east.frontend.public.atl-paas.net',
		graphStoreUrl: 'https://ari-graph-store.staging.atl-paas.net',
	},
	production: {
		atlassianHomeUrl: 'https://home.atlassian.com',
		atlassianAccountUrl: 'https://id.atlassian.com',
		serviceUrl: 'https://teamworkgraph.com',
		graphStoreUrl: isLocalDev ? '/api/graph-store' : 'https://ari-graph-store.staging.atl-paas.net',
	},
	development: {
		// Use local proxy to avoid CORS issues
		graphStoreUrl: '/api/graph-store',
	},
	local: {
		// Use local proxy to avoid CORS issues
		graphStoreUrl: '/api/graph-store',
	},
};

export const getConfig = (): {
	isLocalDev: boolean;
	atlassianHomeUrl: string;
	atlassianAccountUrl: string;
	serviceUrl: string;
	graphStoreUrl: string;
	env: 'production' | 'staging' | 'development' | 'local';
} => {
	const env = getEnv();

	return {
		env,
		...config,
		...environmentOverrides[env],
		isLocalDev,
	};
};
